const storyblokToCdn = url => {
  const config = useRuntimeConfig()
  const parsedUrl = new URL(url)
  const pathArray = parsedUrl.pathname.split('.')
  const extension = pathArray[pathArray.length - 1]
  pathArray.pop()
  const filename = pathArray.join('.')
  const isImage = extension === 'jpg' || extension === 'png'

  return `${config.public.cdnURL}pictures/sb_assets${filename}.${isImage ? 'webp' : extension}`
}

export default storyblokToCdn
